import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotHighwayAlertsApiMeta } from "../apiMeta";
import {
  type AlertsInput,
  alertsInputSchema,
} from "./shared/highwayAlerts.input";
import { type Alert, alertSchema } from "./shared/highwayAlerts.output";

/**
 * Metadata for the fetchAlerts endpoint
 */
export const alertsMeta = {
  functionName: "fetchAlerts",
  endpoint: "/getAlertsAsJson",
  inputSchema: alertsInputSchema,
  outputSchema: alertSchema.array(),
  sampleParams: {},
  endpointDescription: "List all current highway alerts statewide.",
} satisfies EndpointMeta<AlertsInput, Alert[]>;

const { fetch, useHook } = createFetchAndHook<AlertsInput, Alert[]>({
  api: wsdotHighwayAlertsApiMeta,
  endpoint: alertsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/highwayAlerts.endpoints").highwayAlertsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving all current highway alerts statewide
 */
export const fetchAlerts: FetchFactory<AlertsInput, Alert[]> = fetch;

/**
 * React Query hook for retrieving all current highway alerts statewide
 */
export const useAlerts: HookFactory<AlertsInput, Alert[]> = useHook;
